import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import Box from "@mui/material/Box";
import {Button, Paper} from "@mui/material";
import {Link, useLocation, useNavigate} from "react-router-dom";
import RequestsCuttingService from "../../../../../API/orders/optimization/organization/RequestsCuttingService";
import ModalUpdateStatus from "../ModalUpdateStatus";
import OptimizationService from "../../../../../API/orders/optimization/organization/OptimizationService";
import {requestsCuttingStatuses} from "../../../../../data/RequestsCuttingState";
import DateRangeFilter from "../../../filter/DateRangeFilter";
import DateTimeUtil from "../../../../../utils/common/DateTimeUtil";
import FileService from "../../../../../API/orders/orders/organization/FileService";
import ModalAddDetailOrRequestsCuttingForFiles from "../../cutting/details/ModalAddDetailOrRequestsCuttingForFiles";
import ModalOpenCreatePlanOrOptimization from "../plans/ModalOpenCreatePlanOrOptimization";
import ModalSetOptimization from "./ModalSetOptimization";
import ModalConfirm from "../../../modal/ModalConfirm";
import ButtonCreate from "../../../button/ButtonCreate";
import ModalAddCustomerRequestCutting from "./ModalAddCustomerRequestCutting";
import CustomerRequestsCuttingService
    from "../../../../../API/orders/optimization/customer/CustomerRequestsCuttingService";
import MenuItem from "@mui/material/MenuItem";
import {constantsErrorMessages} from "../../../../../Constants";
import ModalAlert from "../../customer-detales/ModalAlert";
import ButtonSelectAction from "../../../button/ButtonSelectAction";
import {ModalSelectAction} from "../../../modal/ModalSelectAction";
import {EditLocalStoragePagesData} from "../../../../../utils/EditLocalStoragePagesData";
import selectionTableUtil, {normalizeSelection} from "../../../../../utils/common/SelectionTableUtil";
import {calcFilterData} from "../../../../../utils/common/calcFilterData";
import OrderUtil from "../../../../../utils/orders/OrderUtil";
import {RequestsCuttingFilterData} from "../../../../../data/FilterTables/RequestsCuttingFilterData";
import CircularProgress from "@mui/material/CircularProgress";
import {
    buildWorkingCuttingMapLinkPath,
    enrichRequestsCuttingRows,
    getRequestsCuttingMaterialName,
    getRequestsCuttingOptimizations,
    getRequestsCuttingOrderNumber,
    getRequestsCuttingPlanId,
    getRequestsCuttingPlanName,
    getRequestsCuttingWorkingCuttingMaps,
} from "../../../../../utils/orders/RequestsCuttingUtil";

const RequestsCuttingTable = ({
                                  getAll,
                                  optimizationId,
                                  isOptimization,
                                  isRedirectRequestsCutting,
                                  orderId,
                                  requestsCuttingPlan,
                                  planId,
                                  isOrder,
                                  isButtonAddRequestsCutting,
                                  isPlan,
                                  isRedirectOrder,
                                  nameOrder,
                                  idHeader,
                                  year,
                                  isRedirectArchive,
                                  isRedirectOrders,
                                  isRedirectPlans,
                                  isRedirectOptimizations,
                                  isCreateOptimization,
                                  isCreateOptimizationCalculation,
                                  isDeleteOptimization,
                                  isAddOptimization,
                                  isArchive,
                                  isSetForOptimization,
                                  page,
                                  hideOrder,
                                  hideWorkingCuttingMap,
                                  customer,
                                  isRedirectCalculationOptimizations,
                                  isRedirectCalculationCalculationWorkingCuttingMaps,
                                  isRedirectCalculationRequestsCuttings,
                                  customerOrderNumber,
                                  isCalculation,
                                  isButtonCreate,
                                  deleteRowBeforeAction,
                                  isCloud,
                                  enableRowSelection = (state) => true,
                                  isOrgOne,
                                  offersData
                              }) => {

        const pathname = useLocation().pathname
        const [customerRequestsCuttingModalOpen, setCustomerRequestsCuttingModalOpen] = useState(false);

        const [open, setOpen] = useState(false)
        const [isFullScreen, setIsFullScreen] = useState(false);
        const [data, setData] = useState([]);
        const [change, setChange] = useState(false);
        const [rowSelection, setRowSelection] = useState([]);

        const [updateModalOpen, setUpdateModalOpen] = useState(false);

        const [modalAddRequestsCuttingOpen, setModalAddRequestsCuttingOpen] = useState(false);
        const [calculationRequestsCutting, setCalculationRequestsCutting] = useState(false);

        const [currentEditRowData, setCurrentEditRowData] = useState(null);
        const [currentAllowedStatuses, setCurrentAllowedStatuses] = useState(['ARCHIVE']);

        const [currentEditRowId, setCurrentEditRowId] = useState(null);
        const [modalOpenCreateOptimization, setModalOpenCreateOptimization] = useState(false);
        const [newRowDataOptimization, setNewRowDataOptimization] = useState(null);
        const [setOptimizationModalOpen, setSetOptimizationModalOpen] = useState(false);
        const [isCalculationOptimization, setIsCalculationOptimization] = useState(null);
        const [showConfirmationModalDeleteOptimization, setShowConfirmationModalDeleteOptimization] = useState(false);

        const [showConfirmationModalSetForCalculation, setShowConfirmationModalSetForCalculation] = useState(false);

        const [statusList, setStatusList] = useState([]);
        const [filteredData, setFilteredData] = useState(data)
        const [globalFilter, setGlobalFilter] = useState('');
        const [columnsFilter, setColumnsFilter] = useState([]);
        const [showColumnFilters, setShowColumnFilters] = useState(false)
        const [isLoading, setIsLoading] = useState(true)
        const [loading, setLoading] = useState(false)
        const [tableOptions, setTableOptions] = useState({
            pageIndex: 0,
            pageSize: 100,
            totalElements: 0,
            searchData: ""
        })

        const handleShowColumnFilters = () => {
            setShowColumnFilters(!showColumnFilters)
            if (showColumnFilters) {
                handleSearchQuery([], data, null, true)
            }
        }
        const tableOptionsHandle = (nextState) => {
            setTableOptions(nextState)
            if (nextState.pageSize !== tableOptions.pageSize) {
                EditLocalStoragePagesData(pathname, "pageSize", nextState.pageSize)
            }
        }
        const handleSearchQuery = (searchQuery, prevData, pageSize, isColumnFilters) => {
            const newColumnsFilter = isColumnFilters ? searchQuery : columnsFilter
            const newGlobalFilter = isColumnFilters ? globalFilter : searchQuery || ""

            const data = [...prevData]
            const globalFilterData = newGlobalFilter ? calcFilterData(data, newGlobalFilter, RequestsCuttingFilterData) : data
            const newData = newColumnsFilter.reduce((accumulator, currentValue) => {
                return calcFilterData(accumulator, currentValue?.value, [RequestsCuttingFilterData.find(el => el.idFromColumnFilter === currentValue.id)])
            }, globalFilterData);

            setFilteredData(newData)

            tableOptionsHandle({
                ...tableOptions,
                totalElements: newData.length,
                pageSize: pageSize ? pageSize : tableOptions?.pageSize
            })

            if (isColumnFilters) {
                setColumnsFilter(searchQuery)
            } else {
                setGlobalFilter(searchQuery || "")
                if (searchQuery !== globalFilter) {
                    EditLocalStoragePagesData(pathname, "searchQuery", searchQuery)
                }
            }
        }
        const getStartPageSize = () => {
            const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
            const pageSize = pagesData[pathname]?.pageSize
            const searchQuery = pagesData[pathname]?.searchQuery

            return {searchQuery, pageSize}
        }
        const {onRowSelectionChange} = selectionTableUtil(data, setRowSelection)
        const currentSelection = normalizeSelection(rowSelection)
        const [alertData, setAlertData] = useState({});
        useEffect(() => {
                const {searchQuery, pageSize} = getStartPageSize()
                const id = isOrder ? orderId : (requestsCuttingPlan ? planId : optimizationId);
                getAll(id, isCalculation).then(function (response) {
                    let data = enrichRequestsCuttingRows(response.data);
                    setData(data);
                    handleSearchQuery(searchQuery, data, pageSize)
                    setStatusList(OrderUtil.getListFieldByEnum(data, 'requestsCuttingState', requestsCuttingStatuses));
                })
                    .catch(function (error) {
                        handleModalAlert(error);
                    }).finally(() => setIsLoading(false))
            }, [change]
        );
        const handleModalAlert = (message, type = "error") => {
            setAlertData({
                type: type,
                open: true,
                message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
            })
        }
        const handleDeleteRow = useCallback(
            (row) => {
                const id = row.id;
                const service = customer ? CustomerRequestsCuttingService : RequestsCuttingService
                service.delete(id)
                    .then(function () {
                        const newData = data.filter(el => el.id !== id)
                        setData(newData)
                        handleSearchQuery(globalFilter, newData)
                        handleModalAlert("Данные удалены", 'success')
                    })
                    .catch(function (error) {
                        handleModalAlert(error);
                    })
                setCurrentEditRowData(null)
            },
            [data],
        );
        const onClose = () => {
            setCurrentEditRowData(null)
            setCustomerRequestsCuttingModalOpen(false)
        }
        const handleUpdateRow = (value, onClose) => {
            setLoading(true)
            CustomerRequestsCuttingService.edit(currentEditRowData.id, {
                "materialId": value?.material,
                "note": value?.note || null,
                materialOrganizationOptionId: null
            })
                .then(function (response) {
                    const newData = data.map(el => el.id === response.data.id ? response.data : el)
                    setData(newData)
                    handleSearchQuery(globalFilter, newData)
                    handleModalAlert("Данные изменены", 'success')
                    onClose()
                })
                .catch(function (error) {
                    handleModalAlert(error)
                })
                .finally(() => setLoading(false))
        }

        const handleUpdateModel = useCallback(
            (row) => {
                setCurrentAllowedStatuses([...currentAllowedStatuses, row.original.requestsCuttingState]);
                setCurrentEditRowData(row.original);
                setCurrentEditRowId(row.index);
                setUpdateModalOpen(true);
            },
            [data, currentEditRowData, setCurrentEditRowData],
        );

        const handleClose = () => {
            currentAllowedStatuses.splice(1, 1);
            setUpdateModalOpen(false)
        };

        const navigate = useNavigate();

        const submitCustomerRequestsCutting = (value, onClose) => {
            setLoading(true)
            const api = customer ? CustomerRequestsCuttingService.add({
                "materialId": value?.material,
                "note": value?.note || null,
                "orderId": orderId
            }) : RequestsCuttingService.add(value.material)
            api.then(function (response) {
                const newData = [...data, response.data]
                setData(newData)
                handleSearchQuery(globalFilter, newData)
                handleModalAlert("Данные добавлены", 'success')
                onClose()
            })
                .catch(function (error) {
                    handleModalAlert(error);
                })
                .finally(() => setLoading(false))
        }
        const customerEditRequestsCutting = (row) => {
            setCurrentEditRowData(row)
            setCustomerRequestsCuttingModalOpen(true)
        };

        const createOptimizationByIds = () => {
            setLoading(true)
            const requestsCuttingState = isCalculationOptimization ? 'FORMED_CALCULATION_OPTIMIZATION' : 'FORMED_OPTIMIZATION';
            OptimizationService.createOptimizationByIds(rowSelection, newRowDataOptimization)
                .then(function (response) {
                    const newData = deleteRowBeforeAction ? data.filter(item => {
                        return !rowSelection.includes(item.id)
                    }) : data.map(item => {
                        if (rowSelection.includes(item.id)) {
                            return {
                                ...item,
                                optimization: response.data,
                                requestsCuttingState: requestsCuttingState
                            };
                        } else {
                            return item;
                        }
                    })
                    deleteRowBeforeAction && setTableOptions((prev) => ({...prev, totalElements: data.length - 1}))
                    setData(newData);
                    handleSearchQuery(globalFilter, newData)
                    handleCloseModalOpenCreateOptimization();
                    setChange(!change)
                    handleModalAlert("Оптимизация создана", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
                .finally(() => setLoading(false))
        };

        const deleteOptimizationByIds = () => {
            setLoading(true)
            const requestsCuttingState = isCalculationOptimization ? 'CALCULATION' : 'EXPECTATION';
            RequestsCuttingService.deleteOptimizationByIds(rowSelection, isCalculation)
                .then(function () {
                    const newData = deleteRowBeforeAction ? data.filter(item => {
                        return !rowSelection.includes(item.id)
                    }) : data.map(item => {
                        if (rowSelection.includes(item.id)) {
                            return {
                                ...item,
                                optimization: null,
                                requestsCuttingState: requestsCuttingState
                            };
                        } else {
                            return item;
                        }
                    })
                    deleteRowBeforeAction && setTableOptions((prev) => ({...prev, totalElements: data.length - 1}))
                    setData(newData);
                    handleSearchQuery(globalFilter, newData)
                    handleCloseDeleteOptimization();
                    handleModalAlert("Оптимизация удалена", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
                .finally(() => setLoading(false))
        };

        const handleCloseModalOpenCreateOptimization = () => {
            setModalOpenCreateOptimization(false);
            setRowSelection([]);
        };

        const handleCloseDeleteOptimization = () => {
            setShowConfirmationModalDeleteOptimization(false);
            setRowSelection([]);
        };


        const handleCloseSetForCalculation = () => {
            setShowConfirmationModalSetForCalculation(false);
            setRowSelection([]);
        };

        const redirectRequestsCutting = () => {
            navigate('/organization/requests-cutting');
        };

        const redirectOrders = () => {
            navigate('/organization/orders');
        };
        const redirectArchive = () => {
            navigate('/organization/requests-cutting/archive');
        };

        const redirectPlans = () => {
            navigate('/organization/plans');
        };

        const redirectOptimizations = () => {
            navigate('/organization/optimizations');
        };

        const redirectOrder = () => {
            navigate('/organization/orders/' + orderId + '/' + encodeURIComponent(nameOrder) + '/' + idHeader + '/' + year);
        };

        const redirectCalculationWorkingCuttingMaps = () => {
            navigate('/organization/working-cutting-maps-calculation');
        };

        const redirectCalculationOptimizations = () => {
            navigate('/organization/optimizations-calculation');
        };


        const redirectCalculationRequestsCutting = () => {
            navigate('/organization/requests-cutting/Calculation');
        }

        const addAndCalculateRequestsCutting = () => {
            setCalculationRequestsCutting(true);
            setModalAddRequestsCuttingOpen(true)
        };

        const columns = useMemo(() => {
            const baseColumns = [
                {
                    id: 'number',
                    header: 'Номер',
                    accessorKey: 'number',
                    minSize: 8,
                    maxSize: 8,
                    Cell: ({cell, row}) => {
                        return (
                            <span
                                style={{
                                    color: row.original.placeholder ? 'red' : 'black'
                                }}>
                               {cell.getValue()}
                            </span>
                        );
                    }
                },
                {
                    id: 'nominalQuantity',
                    header: 'Ном. кв.м.',
                    accessorKey: 'nominalQuantity',
                    minSize: 15,
                    maxSize: 15,
                    Cell: ({cell}) => cell.getValue() === null ? null : cell.getValue()?.toFixed(3),
                },
                {
                    id: 'thickness',
                    header: 'Толщина',
                    accessorKey: 'thickness',
                    minSize: 8,
                    maxSize: 8,
                },
                {
                    accessorFn: (row) => {
                        if (row.dateOfReceipt === null) {
                        } else {
                            return new Date(row.dateOfReceipt)
                        }
                    },
                    id: 'date',
                    header: 'Дата поступления',
                    accessorKey: 'date',
                    sortingFn: 'datetime',
                    size: 10,
                    Cell: ({cell}) => {
                        if (cell.getValue() !== undefined) {
                            return cell.getValue().toLocaleDateString();
                        }
                    },
                    Filter: ({column}) => <DateRangeFilter
                        column={column}
                    />,
                },
                {
                    id: 'note',
                    header: 'Комментарий',
                    accessorKey: 'note',
                    minSize: 8,
                    maxSize: 8,
                },

                {
                    header: 'id',
                    accessorKey: 'id',
                    enableColumnActions: false,
                    enableGrouping: false,
                    enableEditing: false,
                    size: 2,
                    maxSize: 2,
                },
            ];

            if (customer) {
                baseColumns.splice(1, 0, {
                    id: 'materialName',
                    header: 'материал',
                    accessorKey: 'materialName',
                    minSize: 150,
                    maxSize: 150,
                    Cell: ({cell, row}) => (
                        <li key={cell.getValue()}>
                            <Link
                                style={{
                                    textDecorationColor: row.original.placeholder ? 'red' : '#006CCC;'
                                }}
                                to={'/customer/orders/' + orderId + "/" + encodeURIComponent(customerOrderNumber) + "/" + year + '/requests-cutting/' + row.original.id + "/" + encodeURIComponent(row.original.number) + '/details?materialId=' + row.original.materialId}>
                                <span
                                    style={{
                                        color: row.original.placeholder ? 'red' : '#006CCC;',
                                    }}>
                              {cell.getValue() === null ? '' : cell.getValue()}
                            </span>
                            </Link>
                        </li>
                    ),
                });
            }

            if (!customer) {
                baseColumns.splice(1, 0, {
                    id: 'materialOrganizationOption',
                    header: 'материал',
                    accessorFn: (row) => getRequestsCuttingMaterialName(row),
                    minSize: 150,
                    maxSize: 300,
                    Cell: ({cell, row}) => (
                        <li key={cell.getValue()}>
                            <Link
                                to={`/organization/requests-cutting/details/${row.original.id}/${encodeURIComponent(row.original.number)}${isCloud ? "/cloud" : ""}`}>
                                {cell.getValue() === null ? '' : cell.getValue()}
                            </Link>
                        </li>
                    ),
                });
                baseColumns.splice(10, 0, {
                    id: 'requestsCuttingState',
                    header: 'Статус',
                    accessorKey: 'requestsCuttingState',
                    minSize: 55,
                    maxSize: 55,
                    filterVariant: 'multi-select',
                    filterSelectOptions: statusList,
                    Cell: ({cell}) => requestsCuttingStatuses[cell.getValue()],
                    filterFn: (row, id, filterValue) => {
                        return requestsCuttingStatuses[row.original.requestsCuttingState].toLowerCase().includes(filterValue.toLowerCase())
                    },
                    muiFilterTextFieldProps: {
                        placeholder: 'Отфильтровать по статус',
                        sx: {
                            width: '350px',
                        },
                    }
                });
            }

            if (!hideOrder) {
                baseColumns.splice(3, 0, {
                    id: 'order',
                    header: 'Номер заказа',
                    accessorFn: (row) => getRequestsCuttingOrderNumber(row),
                    minSize: 8,
                    maxSize: 8,
                });
            }

            if (!hideWorkingCuttingMap) {
                baseColumns.splice(2, 0, {
                    id: 'workingCuttingMap',
                    header: 'К. раскроя',
                    accessorFn: (row) => row.workingCuttingMapDisplay
                        ?? getRequestsCuttingWorkingCuttingMaps(row).map((map) => map.number).join(' / '),
                    minSize: 15,
                    maxSize: 15,
                    Cell: ({row}) => {
                        const maps = getRequestsCuttingWorkingCuttingMaps(row.original);
                        if (maps.length === 0) {
                            return '';
                        }

                        return (
                            <li>
                                {maps.map((map, index) => {
                                    const mapPath = buildWorkingCuttingMapLinkPath(row.original, {
                                        isCloud,
                                        mapId: map.id,
                                        mapNumber: map.number,
                                    });
                                    return (
                                        <span key={map.id}>
                                            {index > 0 && ' / '}
                                            {mapPath ? <Link to={mapPath}>{map.number}</Link> : map.number}
                                        </span>
                                    );
                                })}
                            </li>
                        );
                    },
                });
            }

            if (isOptimization) {
                baseColumns.splice(3, 0, {
                    id: 'optimization',
                    header: 'Оптимизация',
                    accessorFn: (row) => row.optimizationDisplay
                        ?? getRequestsCuttingOptimizations(row).map((opt) => opt.number).join(' / '),
                    minSize: 150,
                    maxSize: 150,
                    Cell: ({row}) => {
                        const optimizations = getRequestsCuttingOptimizations(row.original);
                        if (optimizations.length === 0) {
                            return '';
                        }

                        return (
                            <li>
                                {optimizations.map((opt, index) => (
                                    <span key={opt.id}>
                                        {index > 0 && ' / '}
                                        <Link
                                            to={`/organization/requests-cutting/optimization/${opt.id}/${encodeURIComponent(opt.number)}`}>
                                            {opt.number}
                                        </Link>
                                    </span>
                                ))}
                            </li>
                        );
                    }
                });
            }

            if (isPlan) {
                baseColumns.splice(4, 0, {
                    id: 'plan',
                    header: 'План',
                    accessorFn: (row) => getRequestsCuttingPlanName(row),
                    minSize: 8,
                    maxSize: 8,
                    Cell: ({cell, row}) => {
                        const planId = getRequestsCuttingPlanId(row.original);
                        const planName = getRequestsCuttingPlanName(row.original);
                        return planName && planId ? (
                            <li key={planName}>
                                <Link
                                    to={'/organization/requests-cutting/plan/' + planId + '/' + encodeURIComponent(planName)}>
                                    {planName}
                                </Link>
                            </li>
                        ) : (planName ?? '');
                    },
                });
            }

            return baseColumns;
        }, [data, setData, isOptimization, filteredData]);

        const menuItem = [
            {type: "delete", text: "Удалить", handler: handleDeleteRow},
            {type: "edit", text: "Изменить", handler: customerEditRequestsCutting}
        ]

        const modalActions = (() => {
            const actions = [];

            if (isCreateOptimizationCalculation) {
                actions.push({name: "Создать расчетную оптимизацию", type: "optimizationCalc"});
            }
            if (isCreateOptimization) {
                actions.push({name: "Создать оптимизацию", type: "optimization"});
            }
            if (isDeleteOptimization) {
                actions.push(
                    {name: "Удалить оптимизацию", type: "delete"},
                );
            }
            if (isAddOptimization) {
                actions.push(
                    {name: "Переместить в оптимизацию", type: "add"},
                );
            }
            return actions;
        })();

        const createOptimization = (optimizationState) => {
            const number = optimizationState === 'CALCULATION' ? "СOP" : "OP";
            const optimization = {
                id: null,
                number: number,
                optimizationState: optimizationState,
                optimized: null,
            }
            setNewRowDataOptimization(optimization);
            setIsCalculationOptimization(optimizationState === 'CALCULATION');
            setModalOpenCreateOptimization(true)
        };

        const handleSelectAction = (type) => {
            if (type === "optimizationCalc") {
                createOptimization('CALCULATION')
            } else if (type === "optimization") {
                createOptimization('EXPECTATION')
            } else if (type === "add") {
                setSetOptimizationModalOpen(true)
            } else if (type === "delete") {
                setShowConfirmationModalDeleteOptimization(true)
            } else if (type === "return") {
                setShowConfirmationModalSetForCalculation(true)
            }
            setOpen(false)
        }

        return (
            <div>
                <Box
                    sx={{display: 'flex', justifyContent: "flex-end", gap: "10px", paddingBottom: "30px"}}
                >
                    {isButtonCreate && !isCloud && <ButtonCreate
                        text={"Добавить заявку на раскрой"}
                        width={270}
                        onClick={() => setCustomerRequestsCuttingModalOpen(true)}
                    />}
                    {isRedirectArchive && <ButtonCreate
                        text={"Архив"}
                        icon={false}
                        width={70}
                        onClick={redirectArchive}
                    />}
                    {isRedirectOrders && <ButtonCreate
                        text={"Заказы"}
                        icon={false}
                        width={70}
                        onClick={redirectOrders}
                    />}
                    {isRedirectPlans && <ButtonCreate
                        text={"Планы"}
                        icon={false}
                        width={70}
                        onClick={redirectPlans}
                    />}


                    {isRedirectRequestsCutting && <ButtonCreate
                        text={"Заявки на раскрой"}
                        icon={false}
                        width={160}
                        onClick={redirectRequestsCutting}
                    />}
                    {isRedirectOptimizations && <ButtonCreate
                        text={"Оптимизации"}
                        icon={false}
                        width={120}
                        onClick={redirectOptimizations}
                    />}
                    {isRedirectCalculationRequestsCuttings && <ButtonCreate
                        text={"Рас. заявки на раскрой"}
                        icon={false}
                        width={200}
                        onClick={redirectCalculationRequestsCutting}
                    />}
                    {isRedirectCalculationOptimizations && <ButtonCreate
                        text={" Рас. оптимизации"}
                        icon={false}
                        width={160}
                        onClick={redirectCalculationOptimizations}
                    />}
                </Box>
                {isLoading ?
                    <Box sx={{
                        height: `calc(100vh - 435px)`,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}>
                        <CircularProgress disableShrink/>
                    </Box> : <MaterialReactTable
                        renderTopToolbar={({table}) => {
                            return <Box sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                padding: "7px",
                                backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                            }}>
                                <MRT_ToolbarAlertBanner table={table}/>
                                <Box sx={{display: "flex"}}>
                                    <MRT_ToggleFiltersButton table={table}/>
                                    <MRT_GlobalFilterTextField table={table}/>
                                </Box>
                            </Box>
                        }}
                        selectAllMode={"all"}
                        muiTableBodyCellProps={{
                            sx: {
                                p: '0px 0px 0px 10px',
                                m: '0px 0px 0px 0px',
                                border: "none",
                                "&:after": {
                                    display: "none",
                                },
                                "& td:after": {
                                    "&:hover": {
                                        backgroundColor: "red"
                                    }
                                },
                                "&:not(:last-of-type)": {
                                    borderRight: '1px solid #EAEBEA',

                                },
                                "&:first-of-type": !isArchive && {
                                    padding: 0,
                                    width: "100%",
                                    height: "36px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    color: (theme) => theme.palette.text.light,
                                    "& .MuiButtonBase-root": {
                                        borderRadius: "4px",
                                        width: "24px",
                                        height: "24px",
                                        opacity: 1,
                                        margin: 0,
                                        padding: 0,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.stroke,
                                        }
                                    }
                                },
                                "& li": {
                                    listStyleType: "none",
                                    "& a": {
                                        color: "#006CCC",
                                        textDecoration: "none",
                                        "&:hover": {
                                            textDecoration: "underline"
                                        }
                                    }
                                }
                            },
                        }}
                        muiTableHeadCellProps={{
                            sx: {
                                border: '1px solid #EAEBEA',
                                backgroundColor: "#F5F6FA",
                                padding: "10px",
                                paddingBottom: " 0.2rem",
                                paddingTop: "0.2rem",
                                "& .MuiCollapse-root .MuiSelect-select": {
                                    padding: "0 !important",
                                    "& .MuiChip-label": {
                                        paddingLeft: "5px",
                                        paddingRight: "5px",
                                    }
                                }
                            },
                        }}
                        muiTableBodyRowProps={({row}) => {
                            return ({
                                sx: () => ({
                                    height: '36px',
                                    backgroundColor: "white",
                                    "&:hover& td:after": {
                                        display: "none",
                                    },
                                    "&.MuiTableRow-root.Mui-selected": {
                                        backgroundColor: (theme) => theme.palette.primary.light70,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.light50,
                                        },
                                    },
                                    "&:hover": {
                                        "& td:after": {
                                            display: "none",
                                        },
                                        backgroundColor: (theme) => theme.palette.primary.stroke,
                                    },
                                    '&:nth-of-type(even)': {
                                        "&.MuiTableRow-root.Mui-selected": {
                                            backgroundColor: (theme) => theme.palette.primary.light,
                                            "&:hover": {
                                                backgroundColor: (theme) => theme.palette.primary.light50,
                                            },
                                        },
                                        backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.stroke,
                                        },
                                    },
                                })
                            })
                        }}
                        isFullScreen={isFullScreen}
                        displayColumnDefOptions={{
                            'mrt-row-actions': {
                                header: "",
                                size: 3,
                                minSize: 3,
                                grow: false,
                            },
                        }}
                        muiSearchTextFieldProps={{
                            placeholder: `Поиск`,
                            sx: {
                                paddingTop: "5px",
                                paddingBottom: "0px",
                                "& .MuiCollapse-root": {
                                    borderRadius: '12px',
                                    height: 40, width: 290,
                                    "& .MuiSvgIcon-root": {
                                        color: "#737478"
                                    },
                                    '& .MuiOutlinedInput-input': {
                                        padding: 0
                                    }
                                }
                            },
                            variant: 'outlined',
                        }}
                        columns={columns}
                        data={filteredData}
                        rowHeight={13}
                        columnSpacing={1}
                        initialState={{
                            columnVisibility: {
                                id: false,
                            },
                            isFullScreen: false,
                            density: "compact",
                            pagination: {pageIndex: 0, pageSize: 50},
                        }}
                        onRowSelectionChange={onRowSelectionChange}
                        getRowId={(originalRow) => originalRow.id}
                        onPaginationChange={(updater) => {
                            tableOptionsHandle(updater(tableOptions));
                        }}
                        onGlobalFilterChange={(value) => {
                            handleSearchQuery(value, data, null)
                        }}
                        onColumnFiltersChange={(updater) => {
                            handleSearchQuery(updater(columnsFilter), data, null, true)
                        }}
                        onShowColumnFiltersChange={handleShowColumnFilters}
                        state={{
                            showColumnFilters: showColumnFilters,
                            columnFilters: columnsFilter,
                            globalFilter: globalFilter,
                            rowSelection: currentSelection,
                            showGlobalFilter: true,
                            pagination: tableOptions,
                        }}
                        manualFiltering={true}
                        rowCount={tableOptions.totalElements}
                        enableRowSelection={(customer || isArchive) ? false : (row) => enableRowSelection(row.original.requestsCuttingState)}
                        selectionPadding={1}
                        muiTableContainerProps={{
                            sx: {
                                maxHeight: rowSelection?.length > 0 ? `calc(100vh - 525px)` : `calc(100vh - 435px)`,
                            }
                        }}
                        selectionCss={{
                            backgroundColor: 'lightblue',
                            borderWidth: '2px',
                            borderStyle: 'solid',
                            borderColor: 'blue',
                            borderRadius: '4px',
                        }}
                        muiToolbarAlertBannerProps={{
                            sx: {
                                backgroundColor: (theme) => theme.palette.primary.light,
                                "& .MuiStack-root": {
                                    padding: 0,
                                    "& .MuiBox-root": {
                                        padding: "5px"
                                    }
                                },

                            }
                        }}
                        renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                            const isMenuItemVisible = el.type === "delete" || customer;
                            if (!isMenuItemVisible) {
                                return null;
                            }
                            // Cloud orders have no offersData; customer estimate gates by WAIT_OFFERS.
                            const isMenuItemDisabled = customer
                                ? (!isCloud && offersData?.estimateState !== "WAIT_OFFERS")
                                : row.original.requestsCuttingState !== 'CALCULATION';
                            return <MenuItem
                                disabled={isMenuItemDisabled}
                                key={el.type}
                                onClick={() => {
                                    el.handler(row.original)
                                    closeMenu();
                                }}
                                sx={{
                                    margin: "0 8px",
                                    borderRadius: "4px",
                                    "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                                }}
                            >
                                {el.text}
                            </MenuItem>
                        })}
                        localization={MRT_Localization_RU}
                        enableRowActions={!isArchive}
                        enableToolbarInternalActions={false}
                    />}
                {Object.keys(rowSelection).length !== 0 && <Paper sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    height: "88px",
                    display: 'flex',
                    justifyContent: "center",
                    alignItems: 'center',
                    backgroundColor: (theme) => theme.palette.primary.lightGrey,
                }} component="footer">
                    <ButtonSelectAction text={"Выбрать действие"} onClick={() => setOpen(true)}/>
                </Paper>}
                {!customer && <ModalSelectAction
                    open={open}
                    reset={() => setOpen(false)}
                    submit={handleSelectAction}
                    modalActions={modalActions}
                />}
                <ModalUpdateStatus
                    title={'Обновить статус'}
                    data={data}
                    setData={setData}
                    open={updateModalOpen}
                    handleClose={handleClose}
                    currentEditRowId={currentEditRowId}
                    values={currentEditRowData}
                    setValues={setCurrentEditRowData}
                    currentAllowedStatuses={currentAllowedStatuses}
                    statusesList={requestsCuttingStatuses}
                    field={'requestsCuttingState'}
                    unableStatus={RequestsCuttingService.unableStatus}
                    handleModalAlert={handleModalAlert}
                    handleSearchQuery={handleSearchQuery}
                    globalFilter={globalFilter}
                    loading={loading}
                    setLoading={setLoading}
                />
                <ModalOpenCreatePlanOrOptimization
                    label={'Название оптимизации'}
                    field={'number'}
                    values={newRowDataOptimization}
                    setValues={setNewRowDataOptimization}
                    title={'Создать оптимизацию'}
                    modalOpen={modalOpenCreateOptimization}
                    handleClose={() => setModalOpenCreateOptimization(false)}
                    handleSubmit={createOptimizationByIds}
                    change={change}
                    setChange={setChange}
                    isCalculationOptimization={isCalculationOptimization}
                    loading={loading}
                />
                <ModalAddDetailOrRequestsCuttingForFiles
                    title={'Добавить заявки на раскрой из файлов'}
                    labelForm={'Загрузить заявки на раскрой'}
                    modalOpen={modalAddRequestsCuttingOpen}
                    handleClose={() => setModalAddRequestsCuttingOpen(false)}
                    requestsCuttingId={null}
                    change={change}
                    setChange={setChange}
                    upload={FileService.uploadRequestsCuttingFiles}
                    orderId={orderId}
                    requestsCutting={false}
                    calculationRequestsCutting={calculationRequestsCutting}
                />
                <ModalSetOptimization
                    open={setOptimizationModalOpen}
                    handleClose={() => setSetOptimizationModalOpen(false)}
                    selectedIds={rowSelection}
                    data={data}
                    setData={setData}
                    change={change}
                    handleModalAlert={handleModalAlert}
                    isCalculation={isCalculation}
                    setRowSelection={setRowSelection}
                    deleteRowBeforeAction={deleteRowBeforeAction}
                    setTableOptions={setTableOptions}
                    handleSearchQuery={handleSearchQuery}
                    globalFilter={globalFilter}
                    loading={loading}
                    setLoading={setLoading}
                />
                <ModalConfirm
                    title={"Вы действительно хотите удалить оптимизацию?"}
                    modalOpen={showConfirmationModalDeleteOptimization}
                    handleClose={handleCloseDeleteOptimization}
                    handleSubmit={deleteOptimizationByIds}
                    action={'Удалить'}
                    loading={loading}
                />
                <ModalAddCustomerRequestCutting
                    title={currentEditRowData ? "Изменить заявку на раскрой" : "Добавить заявку на раскрой"}
                    initValue={{material: currentEditRowData?.materialId, note: currentEditRowData?.note}}
                    open={customerRequestsCuttingModalOpen}
                    onClose={onClose}
                    handleSubmit={currentEditRowData ? handleUpdateRow : submitCustomerRequestsCutting}
                    handleModalAlert={handleModalAlert}
                    isCustomer={customer}
                    orderId={orderId}
                    isOrgOne={isOrgOne}
                    loading={loading}
                />
                <ModalAlert data={alertData} onClose={() => setAlertData((alert) => {
                    return {...alert, open: false}
                })}/>
            </div>
        );
    }
;

export default RequestsCuttingTable;
